'use strict';

var baseSvgLocation = '/images/';
var promoGenericLiteral = 'promo-generic.svg';
var internalImageMap = {
  activity: promoGenericLiteral,
  assessment: promoGenericLiteral,
  contact: 'promo-contact.svg',
  coaching: promoGenericLiteral,
  gethelp: 'promo-help.svg',
  history: 'promo-history.svg',
  home: 'promo-home.svg',
  inspiration: promoGenericLiteral,
  inspirations: 'promo-inspirations.svg',
  program: promoGenericLiteral,
  search: 'promo-search.svg',
  tools: 'promo-tools.svg',
  settings: promoGenericLiteral,
  default: promoGenericLiteral
};

(function () {
  'use strict';

  angular.module('vnext').factory('imageMapSvc', imageMapSvc);

  imageMapSvc.$inject = [];

  /* @ngInject */
  function imageMapSvc() {

    return {
      getImageSrc: getImageSrc
    };

    function getImageSrc(promotion) {
      var internalLinkArray = promotion.destination.split(':');
      var destinationBase = internalLinkArray[0];
      var resultUrl = '';

      if (_.isEmpty(destinationBase) || !_.has(internalImageMap, destinationBase)) {
        resultUrl = baseSvgLocation + internalImageMap['default'];
      } else if (!_.isEmpty(promotion.imageUrl) && (destinationBase === 'activity' || destinationBase === 'program' || destinationBase === 'inspiration')) {
        resultUrl = promotion.imageUrl;
      } else {
        resultUrl = baseSvgLocation + internalImageMap[destinationBase];
      }
      return resultUrl;
    }
  }
})();